import { SplitText } from '@/components/motion/SplitText'
import { useSite } from '@/app/site-context'

interface NotFoundPageProps {
  onNavigate: (href: string) => void
}

export function NotFoundPage({ onNavigate }: NotFoundPageProps) {
  const { dictionary, pathFor } = useSite()
  const { notFound } = dictionary
  const home = pathFor('home')

  return (
    <section className="not-found" aria-labelledby="not-found-title">
      <p className="not-found__code" aria-hidden="true">
        {notFound.code}
      </p>
      <h1 className="not-found__title" id="not-found-title">
        <SplitText text={notFound.title} stagger={44} />
      </h1>
      <p className="not-found__body">{notFound.body}</p>
      <a
        className="button button--solid"
        href={home}
        onClick={(event) => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return
          event.preventDefault()
          onNavigate(home)
        }}
      >
        {notFound.cta}
      </a>
    </section>
  )
}
